exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProportionalProgressChart {\n    height: 1.8em;\n    display: flex;\n    justify-content: stretch;\n    border-radius: 1.5em;\n    overflow: hidden;\n}\n\n    .ProportionalProgressChart__item {\n        min-width: 3px;\n        cursor: pointer;\n    }", ""]);

// exports
